"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextboxGroupAddon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _value = require("../../skybase-core/utils/value");

var _textbox = require("./textbox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TextboxGroupAddon = /*#__PURE__*/function (_PureComponent) {
  _inherits(TextboxGroupAddon, _PureComponent);

  var _super = _createSuper(TextboxGroupAddon);

  function TextboxGroupAddon() {
    var _this;

    _classCallCheck(this, TextboxGroupAddon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderLeftPart", function () {
      var _this$props = _this.props,
          addon = _this$props.addon,
          addonPosition = _this$props.addonPosition,
          addonLeft = _this$props.addonLeft,
          addonRight = _this$props.addonRight,
          disabled = _this$props.disabled,
          hasError = _this$props.hasError;

      if (addonLeft) {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('sb-textbox-icon', 'sb-textbox-icon-position-left', {
            disabled: disabled,
            'has-error': hasError
          })
        }, addonLeft), _this.renderPrefix());
      }

      if (!addonRight && addonPosition === 'left' && addon) {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('sb-textbox-icon', 'sb-textbox-icon-position-left', {
            disabled: disabled,
            'has-error': hasError
          })
        }, addon), _this.renderPrefix());
      }

      return _this.renderPrefix(true);
    });

    _defineProperty(_assertThisInitialized(_this), "renderRightPart", function () {
      var _this$props2 = _this.props,
          addon = _this$props2.addon,
          addonPosition = _this$props2.addonPosition,
          addonLeft = _this$props2.addonLeft,
          addonRight = _this$props2.addonRight,
          disabled = _this$props2.disabled,
          hasError = _this$props2.hasError;

      if (addonRight) {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, _this.renderSuffix(), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('sb-textbox-icon', 'sb-textbox-icon-position-right', {
            disabled: disabled,
            'has-error': hasError
          })
        }, addonRight));
      }

      if (!addonLeft && addonPosition === 'right' && addon) {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, _this.renderSuffix(), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('sb-textbox-icon', 'sb-textbox-icon-position-right', {
            disabled: disabled,
            'has-error': hasError
          })
        }, addon));
      }

      return _this.renderSuffix(true);
    });

    _defineProperty(_assertThisInitialized(_this), "renderPrefix", function (noAddon) {
      var _this$props3 = _this.props,
          prefix = _this$props3.prefix,
          disabled = _this$props3.disabled;
      var emptyClass = noAddon ? 'sb-textbox-prefix-empty-no-addon' : 'sb-textbox-prefix-empty';
      var prefixClass = (0, _value.isNullOrUndefined)(prefix) && emptyClass;
      var withAddonClass = noAddon ? '' : 'sb-textbox-prefix-with-addon';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('sb-textbox-prefix', withAddonClass, 'sb-textbox-icon-position-left', prefixClass, {
          disabled: disabled
        })
      }, prefix);
    });

    _defineProperty(_assertThisInitialized(_this), "renderSuffix", function (noAddon) {
      var _this$props4 = _this.props,
          suffix = _this$props4.suffix,
          disabled = _this$props4.disabled;
      var emptyClass = noAddon ? 'sb-textbox-suffix-empty-no-addon' : 'sb-textbox-suffix-empty';
      var suffixClass = (0, _value.isNullOrUndefined)(suffix) && emptyClass;
      var withAddonClass = noAddon ? '' : 'sb-textbox-suffix-with-addon';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('sb-textbox-suffix', withAddonClass, 'sb-textbox-icon-position-right', suffixClass, {
          disabled: disabled
        })
      }, suffix);
    });

    return _this;
  }

  _createClass(TextboxGroupAddon, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          addon = _this$props5.addon,
          prefix = _this$props5.prefix,
          suffix = _this$props5.suffix,
          addonPosition = _this$props5.addonPosition,
          outerClassName = _this$props5.outerClassName,
          disabled = _this$props5.disabled,
          addonLeft = _this$props5.addonLeft,
          addonRight = _this$props5.addonRight,
          hasError = _this$props5.hasError,
          outerStyle = _this$props5.outerStyle,
          rest = _objectWithoutProperties(_this$props5, ["addon", "prefix", "suffix", "addonPosition", "outerClassName", "disabled", "addonLeft", "addonRight", "hasError", "outerStyle"]);

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('sb-textbox-group sb-textbox-group-icon', outerClassName, {
          'has-error': hasError
        }),
        style: outerStyle
      }, this.renderLeftPart(), /*#__PURE__*/_react.default.createElement(_textbox.Textbox, _extends({}, rest, {
        disabled: disabled
      })), this.renderRightPart());
    }
  }]);

  return TextboxGroupAddon;
}(_react.PureComponent);

exports.TextboxGroupAddon = TextboxGroupAddon;
TextboxGroupAddon.propTypes = {
  disabled: _propTypes.default.bool,
  addon: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  addonPosition: _propTypes.default.oneOf(['left', 'right']),
  outerClassName: _propTypes.default.string,
  prefix: _propTypes.default.string,
  suffix: _propTypes.default.string,
  addonLeft: _propTypes.default.node,
  addonRight: _propTypes.default.node,
  hasError: _propTypes.default.bool,
  outerStyle: _propTypes.default.object // eslint-disable-line

};
TextboxGroupAddon.defaultProps = {
  disabled: false,
  addonPosition: 'right',
  outerClassName: '',
  prefix: null,
  suffix: null,
  addon: null,
  addonLeft: null,
  addonRight: null,
  hasError: false,
  outerStyle: {}
};
//# sourceMappingURL=textbox-group-addon.js.map